import React from 'react'
import CartContainer from './CartContainer'
import CartNavbar from './CartNavbar'
import Question from '../Question/Question'
import Footer from '../Footer/Footer'


export default function CartHome() {
  return (
    <>
    <CartNavbar/>
    <CartContainer/>
    <br></br>
    <Question/>
     <br></br>
    <Footer/>
  
    
    </>
  )
}
